"use client";

import Breadcrumbs from "@/components/breadCrumbAndButton/BreadCrumbAndButton";
import "./style.css";
import { useEffect, useRef, useState } from "react";

export default function PricesClientPage() {
  const iframeRef = useRef<HTMLIFrameElement | null>(null);
  const [theme, setTheme] = useState<"light" | "dark">("light");

  useEffect(() => {
    const root = document.documentElement;

    const updateTheme = () => {
      const isDark = root.getAttribute("data-color-scheme") === "dark";
      setTheme(isDark ? "dark" : "light");
    };

    // initial theme
    updateTheme();

    // observe changes in data-color-scheme
    const observer = new MutationObserver(() => {
      updateTheme();
    });

    observer.observe(root, {
      attributes: true,
      attributeFilter: ["data-color-scheme"],
    });

    return () => observer.disconnect();
  }, []);

  const src =
    theme === "dark"
      ? `https://www.tradingview-widget.com/embed-widget/crypto-mkt-screener/?locale=in#%7B%22width%22%3A1200%2C%22height%22%3A4000%2C%22defaultColumn%22%3A%22overview%22%2C%22screener_type%22%3A%22crypto_mkt%22%2C%22displayCurrency%22%3A%22USD%22%2C%22colorTheme%22%3A%22dark%22%2C%22isTransparent%22%3Atrue%2C%22market%22%3A%22crypto%22%2C%22enableScrolling%22%3Atrue%7D`
      : `https://www.tradingview-widget.com/embed-widget/crypto-mkt-screener/?locale=in#%7B%22width%22%3A1200%2C%22height%22%3A4000%2C%22defaultColumn%22%3A%22overview%22%2C%22screener_type%22%3A%22crypto_mkt%22%2C%22displayCurrency%22%3A%22USD%22%2C%22colorTheme%22%3A%22light%22%2C%22isTransparent%22%3Atrue%2C%22market%22%3A%22crypto%22%2C%22enableScrolling%22%3Atrue%7D`;

  return (
    <div className="top-header-price-padding">
      <div className="container">
        <Breadcrumbs
          items={[{ label: "Home", href: "/" }, { label: "Prices" }]}
        />
        <div id="wrapper">
          <div className="container px-0">
            <div className="row">
              <div className="col-sm-12 page-breadcrumb" />
              <div id="content" className="col-sm-12">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="page-content font-text">
                      <h1 className="title">
                        Live Cryptocurrency Prices by Market Cap
                      </h1>

                      <div className="tradingview-widget-container">
                        <iframe
                          ref={iframeRef}
                          key={theme}
                          src={src}
                          frameBorder={0}
                          title="Crypto Market Screener"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
